import { render, staticRenderFns } from "./WebsitesEdit.vue?vue&type=template&id=0c0b8e8d&"
import script from "../websitesedit.js?vue&type=script&lang=js&"
export * from "../websitesedit.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports